module.exports = __webpack_public_path__ + "static/forecast/windstock/calm-de016910c3bc3efa1483b882ebef0271.svg";